import { Button, Icon, Input, message } from "antd";
import Form, { FormComponentProps } from "antd/lib/form";
import * as React from "react";
import { Redirect, RouteProps } from "react-router-dom";
import AuthService from "src/helpers/AuthService";

export interface ILoginProps extends RouteProps {
  location: any;
  form: any;
}

export interface ILoginState {
  redirectToReferrer: boolean;
}

class Login extends React.Component<
  ILoginProps & FormComponentProps,
  ILoginState
> {
  constructor(props: ILoginProps & FormComponentProps) {
    super(props);

    this.state = {
      redirectToReferrer: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer === true) {
      return <Redirect to={from} />;
    }

    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator("userName", {
            rules: [{ required: true, message: "Please input your username!" }]
          })(
            <Input
              prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Username"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "Please input your Password!" }]
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
              type="password"
              placeholder="Password"
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Log in
          </Button>
        </Form.Item>
      </Form>
    );
  }

  private handleSubmit(e: React.FormEvent<any>) {
    e.preventDefault();
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        new AuthService()
          .login(
            this.props.form.getFieldValue("userName"),
            this.props.form.getFieldValue("password")
          )
          .then(({ ok, msg }) => {
            if (ok) {
              this.setState({ redirectToReferrer: true });
            } else {
              if (msg) {
                message.error(msg);
              }
            }
          })
          .catch(error => {
            // tslint:disable-next-line:no-console
            console.log(error);
          });
      }
    });
  }
}

export default Form.create<ILoginProps>()(Login);



// WEBPACK FOOTER //
// ./src/components/auth/login.tsx